import { useI18n } from 'vue-i18n';
import { getLoadTypeDirectionDisplay, LoadTypeDirectionDisplay } from '@nova/core';
import { usePreparationAppointmentsFeature } from '@satellite/composables/usePreparationAppointmentsFeature';

import type { LoadTypeDirectionSubject, Maybe } from '@nova/core';

const DIRECTION_LABEL_KEYS: Record<LoadTypeDirectionDisplay, string> = {
  [LoadTypeDirectionDisplay.Inbound]: 'core.yard.loadTypeDirections.inbound',
  [LoadTypeDirectionDisplay.Outbound]: 'core.yard.loadTypeDirections.outbound',
  [LoadTypeDirectionDisplay.Load]: 'core.yard.loadTypeDirections.load',
  [LoadTypeDirectionDisplay.Unload]: 'core.yard.loadTypeDirections.unload',
  [LoadTypeDirectionDisplay.DropOff]: 'core.yard.loadTypeDirections.dropOff',
  [LoadTypeDirectionDisplay.PickUp]: 'core.yard.loadTypeDirections.pickUp',
  [LoadTypeDirectionDisplay.DropAndHook]: 'core.yard.loadTypeDirections.dropAndHook',
  [LoadTypeDirectionDisplay.InboundAndOutbound]: 'core.yard.loadTypeDirections.inboundAndOutbound'
};

export function useLoadTypeDirectionLabel() {
  const { t } = useI18n();
  const { isPreparationAppointmentsEnabled } = usePreparationAppointmentsFeature();

  // Null when the feature is off or the direction is unknown, so callers keep their existing label.
  function getDirectionLabel(loadType: Maybe<LoadTypeDirectionSubject>): Maybe<string> {
    if (!isPreparationAppointmentsEnabled.value) {
      return null;
    }

    const display = getLoadTypeDirectionDisplay(loadType);

    return display ? t(DIRECTION_LABEL_KEYS[display]) : null;
  }

  return { getDirectionLabel };
}
